/*!
 * name ZJX 公共轮播图
 * Copyright 2018-2019
 */
<template>
  <div>
    <div class="banner_conntet" id="banner_conntet">
      <el-carousel :interval="3000" arrow="never" indicator-position="none">
        <el-carousel-item v-for="(item,index) in imgList" :key="index">
<!--          <img class="banner_img" :src="item.src" :alt="item.id">-->
          <div class="banner_img" :style="{ backgroundImage:'url('+ item.src +') '}"></div>
        </el-carousel-item>
      </el-carousel>
      <!--<img class="banner_img" src="../assets/images/banner.png" >-->
      <div class="banner_bg"></div>
      <div class="banner_con_bg"></div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {

    };
  },
  computed: {},
  mounted() {
    //原生获取屏幕高度
    var orderWidth = document.body.clientWidth;
    document.getElementById("banner_conntet").style.width = orderWidth + "px";
    document.getElementById("banner_conntet").style.marginLeft =
      -(orderWidth / 2) + "px";
  },
  methods: {},
  created() {},
  watch: {
    $route(val, oldval) {}
  },
  props: {
      imgList:{
          type:Array,
          required:true
      }
  }
};
</script>

<style lang="scss">
.banner_conntet {
  height: 450px;
  position: absolute;
  left: 50%;
  top: 0;
  box-sizing: border-box;
  z-index: 8;
}
.el-carousel{width:100%; position: absolute;left:0;top:0;}
.el-carousel__container{height:450px;}
.el-carousel__item{text-align: center;}
.banner_img{
    width: 100%;
    height: 450px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    /*display: inline-block;*/
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.banner_bg{background:url(../assets/images/banner_bg3.png) no-repeat center bottom; position: absolute;left:0;bottom:-22px;width:100%;height:89px;background-size:100% 100%; z-index: 96;}
.banner_con_bg{width:1000px;height:50px; position: absolute;left:50%;bottom:-28px;margin:0 0 0 -500px;background:url(../assets/images/banner_con_bg.png) no-repeat center bottom; z-index: 97; }

.el-carousel__arrow--left i,.el-carousel__arrow--right i{display:inline-block;background-image:url(http://icon.xcar.com.cn/2014/template/images/slider-arrows.png);background-repeat:no-repeat;width:36px;height:44px}
 .el-carousel__arrow--left i::before,.el-carousel__arrow--right i::before{content:normal;}
 .el-carousel__arrow--left,.el-carousel__arrow--right{display:block;position:absolute;z-index:5;width:36px;height:44px;cursor:pointer;border:1px solid #222;background-color:rgba(0,0,0,.6);filter:progid:DXImageTransform.Microsoft.gradient(enabled='true',startColorstr='#99000000',endColorstr='#99000000');border-radius:0;}
 .el-carousel__arrow--left:hover,.el-carousel__arrow--right:hover{background-color:rgba(0,0,0,1);filter:progid:DXImageTransform.Microsoft.gradient(enabled='true',startColorstr='#ff000000',endColorstr='#ff000000')}
 .el-carousel__arrow--left{left:290px}
 .el-carousel__arrow--left i{background-position:-2px -23px}
 .el-carousel__arrow--right{right:290px}
 .el-carousel__arrow--right i{background-position:-36px -23px}
</style>

